var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "components-container" },
    [
      _c("category-list", {
        attrs: {
          biztype: _vm.constants.categoryType[2],
          "add-perm": "admin:article:category:save",
          "info-perm": "admin:article:category:info",
          "update-perm": "admin:article:category:update",
          "delete-perm": "admin:article:category:delete",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }